// extracted by mini-css-extract-plugin
export default {"root":"ValidationTimeMaskInput_root__OUBEs","errorMessage":"ValidationTimeMaskInput_errorMessage__2ZwWU"};